<template>
  <b-row
    v-if="showBar"
    class="sales-reports-pagination align-items-center mt-3 pt-2"
  >
    <b-col>
      <p class="mb-0 text-dark pagination-total">
        Tổng số: {{ formattedTotal }}
      </p>
    </b-col>
    <b-col>
      <b-pagination
        v-if="numberOfPages >= 2"
        :value="currentPage"
        :total-rows="totalItems"
        :per-page="pageSize"
        class="custom-pagination mb-0"
        align="right"
        first-class="page-item-first btn btn-icon btn-sm m-1"
        prev-class="page-item-prev btn btn-icon btn-sm m-1"
        next-class="page-item-next btn btn-icon btn-sm m-1"
        last-class="page-item-last btn btn-icon btn-sm m-1"
        page-class="btn btn-icon btn-sm border-0 m-1"
        @change="$emit('page-change', $event)"
      >
        <template #first-text>
          <span><i class="ki ki-double-arrow-back icon-xs" /></span>
        </template>
        <template #prev-text>
          <i class="ki ki-arrow-back icon-xs" />
        </template>
        <template #next-text>
          <i class="ki ki-arrow-next icon-xs" />
        </template>
        <template #last-text>
          <span class="text-info">
            <i class="ki ki-double-arrow-next icon-xs" />
          </span>
        </template>
      </b-pagination>
    </b-col>
  </b-row>
</template>

<script>
import { convertPrice } from '@/utils/common';

export default {
  name: 'SalesReportsPagination',
  props: {
    currentPage: {
      type: Number,
      default: 1,
    },
    pageSize: {
      type: Number,
      default: 50,
    },
    totalItems: {
      type: Number,
      default: 0,
    },
    totalPages: {
      type: Number,
      default: 0,
    },
    showWhenSinglePage: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    numberOfPages() {
      if (this.totalPages > 0) {
        return this.totalPages;
      }
      if (!this.pageSize) {
        return 1;
      }
      return Math.max(1, Math.ceil(this.totalItems / this.pageSize));
    },
    showBar() {
      if (this.showWhenSinglePage) {
        return this.totalItems > 0;
      }
      return this.totalItems > 0;
    },
    formattedTotal() {
      return convertPrice(this.totalItems || 0);
    },
  },
};
</script>

<style scoped>
.pagination-total {
  font-weight: 500;
  font-size: 13px;
}
</style>
